export const genders = {
    m: 'male',
    male: 'male',
    f: 'female',
    female: 'female',
};
